export default function () {
    if(process.env.VUE_APP_REGION === 'US'){
        return 'MM/DD/YYYY';
    }else{
        return 'DD/MM/YYYY';
    }
}


